import { mergeClassNames } from "utils/common";

const DefaultMenuItem = ({ children, menuItemClassName }) => {
	return <li className={mergeClassNames("vs--navbar-menu-dropdown-item", menuItemClassName)}>{children}</li>;
};

export default DefaultMenuItem;
